import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Ideia({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Ideia</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1 9.075C17.1 10.2688 16.6215 11.361 15.8207 12.1843C15.1542 12.8695 14.4341 13.8237 14.1543 15H10.7456C10.3832 13.8843 9.63439 12.9884 8.94633 12.3477C8.04521 11.5085 7.5 10.3486 7.5 9.075C7.5 6.59925 9.59715 4.5 12.3 4.5C15.0029 4.5 17.1 6.59925 17.1 9.075ZM10.9668 16.5V18C10.9668 18.8284 11.6384 19.5 12.4668 19.5H12.5335C13.3619 19.5 14.0335 18.8284 14.0335 18V16.5H10.9668ZM15.5335 16.0212C15.5335 14.9498 16.1488 13.9982 16.8959 13.2302C17.9528 12.1436 18.6 10.6822 18.6 9.075C18.6 5.71987 15.7794 3 12.3 3C8.82061 3 6 5.71987 6 9.075C6 10.7909 6.73776 12.3407 7.92409 13.4454C8.76438 14.2279 9.46685 15.2313 9.46685 16.3795V18C9.46685 19.6569 10.81 21 12.4668 21H12.5335C14.1904 21 15.5335 19.6569 15.5335 18V16.0212ZM12.2261 6.68436C12.0251 6.95297 11.6392 6.98884 11.3075 6.93813C11.2516 6.92959 11.195 6.92485 11.1379 6.92404C10.8765 6.92034 10.6207 6.99949 10.407 7.15014C10.1934 7.30079 10.0329 7.51521 9.94864 7.76266C9.93025 7.81665 9.91569 7.8716 9.90497 7.92712C9.84136 8.25655 9.67797 8.60803 9.35745 8.70719C9.03692 8.80634 8.68843 8.62519 8.67088 8.29014C8.65464 7.98021 8.69728 7.66815 8.79853 7.37089C8.96556 6.88056 9.28353 6.45569 9.70687 6.15717C10.1302 5.85866 10.6372 5.70183 11.1551 5.70916C11.4691 5.7136 11.7774 5.77824 12.0639 5.89761C12.3736 6.02665 12.4272 6.41574 12.2261 6.68436Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
